// src/components/Analytics.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TITLE_MAP = {
  "/": "Home",
  "/database": "Database",
  "/taxonomy": "Taxonomy",
  "/taxonomy/taxon-explore": "Taxonomy Explore",
  "/analysis": "Analysis",
  "/analysis/comparison-with-checklists": "Analysis - Comparison with Checklists",
  "/analysis/cumulative-description-trends": "Analysis - Cumulative Description Trends",
  "/analysis/annual-description-trends": "Analysis - Annual Description Trends",
  "/analysis/total-species-estimation": "Analysis - Total Species Estimation",
  "/admin-team": "Admin Team",
  "/admin-team/members": "Admin Team - Members",
  "/admin-team/member-contribution": "Admin Team - Contribution",
  "/admin-team/contact": "Admin Team - Contact",
  "/admin/console-comments": "Admin Console - Comments",
};

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (window.location.hostname === "localhost") return;
    if (!window.gtag) return;
    const sendTo = process.env.REACT_APP_GA_TRACKING_ID;
    const page_path = location.pathname + location.search;
    const page_title = TITLE_MAP[location.pathname] || location.pathname || document.title || undefined;
    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title,
      ...(sendTo ? { send_to: sendTo } : {}),
    });
  }, [location]);

  return null;
}
